export default "__VITE_ASSET__ugjbleXs__"